import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import { AppStateProvider } from './context/app-state-provider';
import { AuthProvider } from './context/auth-provider';
import { AmaWorkflowProvider } from './context/ama-workflow-provider';
import { AmaV2Provider } from './context/ama-v2-provider';
import { DsmProvider } from './context/dsm-provider';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import MuiLicense from './components/mui-license';
import theme from './themes/hce.theme-brian';
import App from './App';

const configureConsoleLogging = (): void => {
  const isProduction = process.env.NODE_ENV === 'production';
  const explicitEnable = process.env.REACT_APP_ENABLE_CONSOLE_LOGS === 'true';

  if (!isProduction || explicitEnable) {
    return;
  }

  const noop = (): void => undefined;
  console.log = noop;
  console.info = noop;
  console.debug = noop;
};

configureConsoleLogging();

const rootElement = document.getElementById('root');  
const root = ReactDOM.createRoot(rootElement!); // eslint-disable-line

root.render(
  <AppStateProvider>
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <AmaWorkflowProvider>
          <AmaV2Provider>
            <DsmProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>              
                <MuiLicense/>      
                <App /> 
              </LocalizationProvider>  
            </DsmProvider>
          </AmaV2Provider>
        </AmaWorkflowProvider>
      </ThemeProvider>
    </AuthProvider>
  </AppStateProvider>);

// Note: using <React.StrictMode> will cause app root to render twice (by design)
// https://stackoverflow.com/questions/61193122/react-default-create-react-app-app-component-rendered-twice